var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mt-3 title-3"},[_vm._v("Limite de Avaliações")]),_c('b-table',{staticClass:"mt-3",attrs:{"fields":_vm.tabela.fields,"items":_vm.items,"empty-text":_vm.$t('GERAL.NENHUM_REGISTRO'),"head-variant":"light","responsive":"sm","show-empty":"","striped":"","hover":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }